/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-sequences */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
import React, { useState, useRef, useEffect } from 'react';
import { MdCheck, MdClear } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useIntl } from 'react-intl';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppSelect from '../../shared/components/app-select/AppSelect';
import AppButton from '../../shared/components/app-button/AppButton';
import './AgentRegistration.scss';
import {
  addAgentApi,
  sendRegistrationOtpApi,
  // uploadImage,
  getCitiesforRegistration,
  verifyRegistrationOtpApi,
  uploadImageForRegistration,
  verifyDocumentNumberApi,
} from '../../api/agentRegistrationApi';
import { stateOptionsObj } from '../../api/stateCityUtils';
import OtpVerificationModal from './OtpVerificationModal';
import AppLink from '../../shared/components/app-link/AppLink';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import {
  countryMobileCodes,
  countryOptionsForHotelPax,
} from '../../shared/constants/CountryOptions';
import {
  checkValidName,
  checkValidEmailAddress,
  NAVIGATION_ROUTES,
  checkValidCompanyName,
} from '../../shared/constants/Constants';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import { useAppContext } from '../../saas/AppConfigWrapper';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import {
  isEmpty,
  isValidMobileNumber,
} from '../../shared/helper-utils/appUtils';
import { getValueFromAppConfig } from '../../shared/helper-utils/localStorage';

export const getLabelForMobileCode = (country) => {
  return (
    <div className="d-flex justify-content-between align-items-center p-1">
      <span className="fs-14">{country.dial_code}</span>
      <div>
        <img
          style={{ width: '17px', height: '15px' }}
          src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/${country.code.toLowerCase()}.svg`}
          alt={country.code}
        />
      </div>
    </div>
  );
};

export const mobileCodesForVerification = countryMobileCodes.map((country) => ({
  label: getLabelForMobileCode(country),
  value: country.code,
}));

export default function AgentRegistration() {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const { appConfig } = useAppContext();
  const [countryCode, setCountryCode] = useState(appConfig.appCountryCode);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [openVerificationPopup, setOpenVerificationPopup] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const userCategoryOptionsRef = useRef([
    { label: 'Agent', value: '30' },
    { label: 'Distributor', value: '31' },
    // { label: 'Individual', value: 'individual' },
    { label: 'CORPORATE', value: 'organization' },
  ]);
  const stateOptionsRef = useRef(stateOptionsObj);
  const cityOptionsRef = useRef([]);
  const panDocRef = useRef(null);
  const gstDocRef = useRef(null);
  const [isAadharSelected, setIsAadharSelected] = useState(false);
  const [isVoterSelected, setIsVoterSelected] = useState(false);
  const [isLicenseSelected, setIsLicenseSelected] = useState(false);
  const [isPassportSelected, setIsPassportSelected] = useState(false);
  const [isVatSelected, setIsVatSelected] = useState(false);
  const [isVatCertificateSelected, setIsVatCertificateSelected] =
    useState(false);
  const [isTradeLicenseSelected, setIsTradeLicenseSelected] = useState(false);
  const [selectedUserIdOption, setSelectedUserIdOption] = useState('mobile');
  const [showCompanyDetails, setShowCompanyDetails] = useState(
    appConfig?.hotelPaxCountry,
  );

  const isIndiaClient = getValueFromAppConfig('isIndiaClient') === 'true';
  const isUAEClient =
    getValueFromAppConfig('UAEclient') === true ||
    getValueFromAppConfig('UAEclient') === 'true';
  const isPanAndGstMandatory =
    String(getValueFromAppConfig('GSTANDPANNONMANDATORY')).toLowerCase() ===
    'true';

  const countryOptions = countryOptionsForHotelPax.map((country) => ({
    label: country,
    value: country,
  }));
  const getDialCode = (code) =>
    countryMobileCodes.find((c) => c.code === code)?.dial_code || '';

  const PAN_REGAX = /^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/;

  // const GST_REGAX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  // const VOTER_REGAX = /^[A-Z]{3}[0-9]{7}$/;

  // const LICENSE_REGAX =
  //   /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/;

  const PASSPORT_REGAX = /^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/i;

  const salutationOptionsRef = useRef([
    {
      label: 'Mr',
      value: 'Mr',
    },
    {
      label: 'Mrs',
      value: 'Mrs',
    },
    {
      label: 'Ms',
      value: 'Ms',
    },
  ]);

  const [alert, setAlert] = useState(undefined);

  const [agent, setAgent] = useState({
    userid: '',
    salutation: '',
    first_name: '',
    last_name: '',
    password: '',
    age: '30',
    contact_email: '',
    mobile_number: '',
    contact_number: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: appConfig?.hotelPaxCountry,
    countrymobilecode: '',
    pincode: '',
    company: '',
    pan_number: '',
    pan_doc_url: '',
    vat_certificate_number: '',
    vat_certificate_doc_url: '',
    trade_license_number: '',
    trade_license_expiry_date: '',
    trade_license_doc_url: '',
    company_incorporation_number: '',
    company_incorporation_doc_url: '',
    tax_identification_number: '',
    tax_identification_doc_url: '',
    iata_number: '',
    iata_certificate_url: '',
    membership_cert_number: '',
    membership_cert_doc_url: '',
    system_roleid: '3',
    user_roleid: '1000',
    status: 'active',
    name_pancard: '',
    currency: appConfig?.appCurrency,
    user_category: '30',
    gst_number: '',
    gst_phone: '',
    gst_address: '',
    gst_email: '',
    gst_holder: '',
    gst_doc_url: '',
    aadhaar_number: '',
    aadhaar_doc_url: '',
    address_doc_url: '',
    driving_license_number: '',
    driving_license_doc_url: '',
    voterid_number: '',
    voterid_doc_url: '',
    passport_front_doc_url: '',
    passport_back_doc_url: '',
    passport_number: '',
    logopath: '',
    tfee: '',
    referrerid: '',
  });

  const [isGstVerified, setGstVerified] = useState(false);
  const [isPanVerified, setPanVerified] = useState(false);
  const [isAadharVerified, setAadharVerified] = useState(false);
  const [gstVerifyStatus, setGstVerifyStatus] = useState('');
  const [aadharVerifyStatus, setAadharVerifyStatus] = useState('');
  const [panVerifyStatus, setPanVerifyStatus] = useState('');
  const [otp, setOtp] = useState('');
  const [requstId, setRequestId] = useState('');
  const [isReferredBySales, setIsReferredBySales] = useState(false);

  const handleSubmit = async () => {
    if (
      isEmpty(agent.salutation) ||
      isEmpty(agent.first_name) ||
      isEmpty(agent.last_name) ||
      isEmpty(agent.contact_email) ||
      isEmpty(agent.mobile_number) ||
      isEmpty(agent.userid) ||
      isEmpty(agent.company) ||
      isEmpty(agent.address1) ||
      isEmpty(agent.pincode) ||
      isEmpty(agent.city) ||
      isEmpty(agent.state) ||
      isEmpty(agent.country) ||
      isEmpty(agent.contact_number) ||
      !isValidMobileNumber(agent.mobile_number, countryCode) ||
      !isValidMobileNumber(agent.contact_number, countryCode)
    ) {
      setValidationError(true);
      return false;
    }
    // const nameRegEx = /^[a-zA-Z0-9!@ ]*$/;
    // if (nameRegEx.test(agent.userid) === false) {
    //   setAlert({
    //     variant: 'error',
    //     title: 'User Id validation',
    //     description: 'Please enter valid userid',
    //   });
    //   return false;
    // }
    if (
      checkValidName(agent.first_name) ||
      checkValidName(agent.last_name) ||
      checkValidName(agent.gst_holder) ||
      checkValidCompanyName(agent.company)
    ) {
      setValidationError(true);
      return false;
    }
    if (!isEmpty(agent.pan_number)) {
      if (PAN_REGAX.test(agent.pan_number) === false) {
        setValidationError(true);
        setAlert({
          variant: 'error',
          title: 'Agent Registration',
          description: 'Enter Valid PAN Number',
        });
        return false;
      }
    }
    // if (!isEmpty(agent.gst_number)) {
    //   if (GST_REGAX.test(agent.gst_number) === false) {
    //     setValidationError(true);
    //     setAlert({
    //       variant: 'error',
    //       title: 'Agent Registration',
    //       description: 'Enter Valid GST Number',
    //     });
    //     return false;
    //   }
    // }
    if (!isEmpty(agent.aadhaar_number) && isAadharSelected) {
      if (agent.aadhaar_number.length !== 12) {
        setValidationError(true);
        setAlert({
          variant: 'error',
          title: 'Agent Registration',
          description: 'Enter Valid Aadhar Number',
        });
        return false;
      }
    }
    if (appConfig?.isGstVerificationrequired && !isGstVerified) {
      setAlert({
        variant: 'error',
        title: 'Verify GST',
        description: 'Please verify GST',
      });
      return false;
    }
    if (appConfig?.isPanVerificationrequired && !isPanVerified) {
      setAlert({
        variant: 'error',
        title: 'Verify PAN',
        description: 'Please verify PAN',
      });
      return false;
    }
    if (appConfig?.isAadharVerificationrequired && !isAadharVerified) {
      setAlert({
        variant: 'error',
        title: 'Verify Aadhar',
        description: 'Please verify Aadhar',
      });
      return false;
    }
    // if (!isEmpty(agent.voterid_number) && isVoterSelected) {
    //   if (VOTER_REGAX.test(agent.voterid_number) === false) {
    //     setValidationError(true);
    //     setAlert({
    //       variant: 'error',
    //       title: 'Agent Registration',
    //       description: 'Enter Valid Voter Number',
    //     });
    //     return false;
    //   }
    // }
    // if (!isEmpty(agent.driving_license_number) && isLicenseSelected) {
    //   if (LICENSE_REGAX.test(agent.driving_license_number) === false) {
    //     setValidationError(true);
    //     setAlert({
    //       variant: 'error',
    //       title: 'Agent Registration',
    //       description: 'Enter Valid License Number',
    //     });
    //     return false;
    //   }
    // }
    if (!isEmpty(agent.passport_number) && isPassportSelected) {
      if (PASSPORT_REGAX.test(agent.passport_number) === false) {
        setValidationError(true);
        setAlert({
          variant: 'error',
          title: 'Agent Registration',
          description: 'Enter Valid Passport Number',
        });
        return false;
      }
    }
    const docs = [
      agent.aadhaar_doc_url,
      agent.voterid_doc_url,
      agent.driving_license_doc_url,
      agent.passport_front_doc_url,
    ];
    const nonEmptyDocs = docs.filter(
      (x) => x !== '' && x !== undefined && x !== undefined,
    );
    // if (nonEmptyDocs && nonEmptyDocs.length < 2) {
    //   setAlert({
    //     variant: 'error',
    //     title: 'Agent Registration',
    //     description: 'Please upload atleast two necessary documents',
    //   });
    //   return false;
    // }
    setIsLoading(true);
    const request = {
      ...agent,
      countrymobilecode: getDialCode(countryCode),
    };
    if (!isAadharSelected) {
      request.aadhaar_doc_url = '';
      request.aadhaar_number = '';
    }
    if (!isVoterSelected) {
      request.voterid_doc_url = '';
      request.voterid_number = '';
    }
    if (!isLicenseSelected) {
      request.driving_license_doc_url = '';
      request.driving_license_number = '';
    }
    if (!isPassportSelected || isUAEClient) {
      request.passport_back_doc_url = '';
      request.passport_front_doc_url = '';
      request.passport_number = '';
    }
    if (isVatSelected) {
      // if intlClient vat details are stored as aadhaar_number,aadhaar_doc_url
      request.tax_identification_doc_url = agent.aadhaar_doc_url;
      request.tax_identification_number = agent.aadhaar_number;
    }
    if (isUAEClient) {
      request.vat_certificate_number = agent.vat_certificate_number;
      request.vat_certificate_doc_url = isVatCertificateSelected
        ? agent.vat_certificate_doc_url
        : '';
      request.trade_license_number = agent.trade_license_number;
      request.trade_license_expiry_date = agent.trade_license_expiry_date;
      request.trade_license_doc_url = isTradeLicenseSelected
        ? agent.trade_license_doc_url
        : '';
      request.company_incorporation_doc_url = isTradeLicenseSelected
        ? agent.trade_license_doc_url || agent.company_incorporation_doc_url
        : '';
    }
    if (!isReferredBySales) {
      request.referrerid = '';
    }
    setValidationError(false);
    const response = await addAgentApi(request);
    if (response) {
      if (response.ApiStatus?.Status === 'OK') {
        setAlert({
          variant: 'success',
          title: 'Agent Registration',
          description: response.ApiStatus.Message,
        });
        setAgent({
          userid: '',
          salutation: '',
          first_name: '',
          last_name: '',
          password: '',
          age: '30',
          contact_email: '',
          mobile_number: '',
          contact_number: '',
          address1: '',
          address2: '',
          city: '',
          state: '',
          country: '',
          countrymobilecode: '',
          pincode: '',
          company: '',
          pan_number: '',
          pan_doc_url: '',
          system_roleid: '3',
          user_roleid: '1000',
          status: 'active',
          name_pancard: '',
          currency: appConfig?.appCurrency,
          user_category: '30',
          gst_number: '',
          gst_phone: '',
          gst_address: '',
          gst_email: '',
          gst_holder: '',
          gst_doc_url: '',
          aadhaar_number: '',
          aadhaar_doc_url: '',
          address_doc_url: '',
          driving_license_number: '',
          driving_license_doc_url: '',
          voterid_number: '',
          voterid_doc_url: '',
          passport_front_doc_url: '',
          passport_back_doc_url: '',
          passport_number: '',
          vat_certificate_number: '',
          vat_certificate_doc_url: '',
          trade_license_number: '',
          trade_license_expiry_date: '',
          trade_license_doc_url: '',
          logopath: '',
          tfee: '',
          referrerid: '',
        });
        setIsAadharSelected(false);
        setIsLicenseSelected(false);
        setIsPassportSelected(false);
        setIsVoterSelected(false);
        setIsVatCertificateSelected(false);
        setIsTradeLicenseSelected(false);
      } else {
        setAlert({
          variant: 'error',
          title: 'Agent Registration',
          description: response?.ApiStatus?.Message,
        });
      }
    } else {
      setAlert({
        variant: 'error',
        title: 'Agent Registration',
        description: 'Failed to register agent. Please try again.',
      });
    }
    setIsLoading(false);
  };

  const getEmailErrorMessage = () => {
    const regEx = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9-_])+\.([a-zA-Z0-9]{2,4})+$/;
    if (isEmpty(agent.contact_email)) {
      return 'Please enter email id';
    }
    if (!regEx.test(agent.contact_email)) {
      return 'Please enter valid email id';
    }
    return '';
  };

  const handleVerifyEmailAndMobileNumber = async () => {
    if (isEmpty(agent.contact_email)) {
      setValidationError(true);
    } else if (isEmpty(agent.mobile_number)) {
      setValidationError(true);
    } else if (agent.mobile_number.length !== 10) {
      setValidationError(true);
    } else {
      setIsLoading(true);
      setValidationError(false);
      const res = await sendRegistrationOtpApi(
        agent.mobile_number,
        agent.contact_email,
      );
      if (res.ApiStatus?.Status === 'OK') {
        setOpenVerificationPopup(true);
      } else {
        setAlert({
          variant: 'error',
          title: 'OTP Verification',
          description: res.ApiStatus?.Message || 'error',
        });
      }
      setIsLoading(false);
    }
  };

  const handleSelectChange = (name, value) => {
    if (value !== null) {
      setAgent((current) => ({
        ...current,
        [name]: value.value,
      }));
    } else {
      setAgent((current) => ({
        ...current,
        [name]: '',
      }));
    }
  };
  const handleSelectChangeCountry = (name, value) => {
    if (value !== null) {
      setAgent((current) => ({
        ...current,
        [name]: value.value,
      }));
      setShowCompanyDetails(value.value === appConfig?.hotelPaxCountry);
    } else {
      setAgent((current) => ({
        ...current,
        [name]: '',
      }));
    }
  };

  const handleOtpVerification = async (emailOtp, mobileOtp) => {
    setOpenVerificationPopup(false);
    setIsLoading(true);
    const response = await verifyRegistrationOtpApi({
      mobilenumber: agent.mobile_number,
      emailid: agent.contact_email,
      mobileotp: mobileOtp,
      emailotp: emailOtp,
    });
    if (response && response.ApiStatus.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'OTP Verification',
        description: 'Your email, mobile number verification success.',
      });
    } else {
      setOpenVerificationPopup(true);
      setAlert({
        variant: 'error',
        title: 'OTP Verification',
        description: 'Failed to verify email, mobile number.',
      });
    }
    setIsLoading(false);
  };

  const handleImageUploadForRegistration = async (
    event,
    documentType,
    docUrl,
  ) => {
    const mappedObjects = {
      pannumber: { name: 'Pan', num: 'pan_number' },
      aadhaar: { name: 'Aadhar', num: 'aadhaar_number' },
      drivinglicence: { name: 'License', num: 'driving_license_number' },
      voterid: { name: 'Voter', num: 'voterid_number' },
      passport: { name: 'Passport', num: 'passport_number' },
      gst: { name: 'GST', num: 'gst_number' },
      incorporation: {
        name: isUAEClient ? 'Trade License' : 'Incorporation',
        num: isUAEClient
          ? 'trade_license_number'
          : 'company_incorporation_number',
      },
      tinvat: {
        name: 'TIN/VAT',
        num: isUAEClient
          ? 'vat_certificate_number'
          : 'tax_identification_number',
      },
      iata: { name: 'IATA', num: 'iata_number' },
      membership: {
        name: 'Membership Certificate',
        num: 'membership_cert_number',
      },
    };

    // Check if document number is filled
    if (agent[mappedObjects[documentType].num] === '') {
      setAlert({
        variant: 'error',
        title: `${mappedObjects[documentType].name} upload`,
        description: `Please enter ${mappedObjects[documentType].name} number`,
      });
      return;
    }

    const file = event.target.files?.[0];
    if (!file) return;

    const fileExtension = file.name.split('.').pop().toLowerCase();
    const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf'];
    // ✅ File type check
    if (
      !allowedExtensions.includes(fileExtension) ||
      !(file.type.startsWith('image/') || file.type === 'application/pdf')
    ) {
      setAlert({
        variant: 'error',
        title: 'Invalid File Type',
        description: 'Only JPG , PNG , PDF files are allowed.',
      });
      event.target.value = '';
      return;
    }

    // ✅ File size check (max 4MB)
    const maxSize = 4 * 1024 * 1024; // 4MB
    if (file.size > maxSize) {
      setAlert({
        variant: 'error',
        title: 'File Too Large',
        description: 'The file size should not exceed 4MB.',
      });
      event.target.value = '';
      setAgent((current) => ({
        ...current,
        [docUrl]: '',
      }));
      return;
    }

    setIsLoading(true);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('uploadtype', documentType);

    const { target } = event;
    const response = await uploadImageForRegistration(formData);

    if (response) {
      if (response.status === 'OK') {
        const imageUrl = response.result;
        setAgent((current) => ({
          ...current,
          [docUrl]: imageUrl,
        }));
        target.value = '';
      } else {
        setAlert({
          variant: 'error',
          title: `${mappedObjects[documentType].name} upload`,
          // description: response.ApiStatus.Message,
          description:
            response?.message ||
            'Failed to upload the document. Please try again.',
        });
      }
    } else {
      setAlert({
        variant: 'error',
        title: `${mappedObjects[documentType].name} upload`,
        description: 'Failed to upload the document. Please try again.',
      });
    }

    setIsLoading(false);
  };
  const handleAlertHide = () => {
    setAlert(undefined);
  };

  // const generateRandomUserId = () => {
  //   if (
  //     !isEmpty(agent.first_name) &&
  //     !isEmpty(agent.last_name) &&
  //     !isEmpty(agent.mobile_number) &&
  //     agent.mobile_number.length === 10
  //   ) {
  //     const first_name = agent.first_name
  //       .toLocaleLowerCase()
  //       .replace(/ /g, '')
  //       .replace(/\d/g, '');
  //     const last_name = agent.last_name
  //       .toLocaleLowerCase()
  //       .replace(/ /g, '')
  //       .replace(/\d/g, '')
  //       .split('');
  //     const phoneDigits = agent.mobile_number
  //       .split('')
  //       .filter((char) => /\d/.test(char));

  //     const getRandomLetter = () => {
  //       const randomIndex = Math.floor(Math.random() * last_name.length);
  //       return last_name[randomIndex];
  //     };

  //     const randomLetter = getRandomLetter();

  //     const randomDigits = [];
  //     while (randomDigits.length < 3 && phoneDigits.length > 0) {
  //       const randomIndex = Math.floor(Math.random() * phoneDigits.length);
  //       randomDigits.push(phoneDigits.splice(randomIndex, 2)[0]);
  //     }
  //     const userID = first_name + randomLetter + randomDigits.join('');
  //     setAgent((current) => ({
  //       ...current,
  //       userid: userID,
  //     }));
  //   }
  // };

  // useEffect(() => {
  //   generateRandomUserId();
  // }, [agent.first_name, agent.last_name, agent.mobile_number]);

  const handleGetUserId = () => {
    const { mobile_number, contact_email } = agent;
    if (selectedUserIdOption === 'mobile') {
      setAgent((prev) => ({
        ...prev,
        userid: mobile_number,
      }));
    }
    if (selectedUserIdOption === 'email') {
      setAgent((prev) => ({
        ...prev,
        userid: contact_email,
      }));
    }
  };

  useEffect(() => {
    handleGetUserId();
  }, [selectedUserIdOption]);

  const getCitiesListForCountry = async () => {
    setIsLoading(true);
    const res = await getCitiesforRegistration(agent.country);
    if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
      let { Result } = res.ApiStatus;
      Result = Array.isArray(Result) ? Result : [Result];
      Result.forEach((d) => {
        (d.label = d.city), (d.value = d.city);
      });
      cityOptionsRef.current = Result;
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getCitiesListForCountry(agent.country);
  }, [agent.country]);

  const handleSetVerifyStatus = (type, status) => {
    switch (type) {
      case 'gst':
        setGstVerifyStatus(status);
        break;
      case 'pan':
        setPanVerifyStatus(status);
        break;
      case 'generateaadhaarotp':
        setAadharVerifyStatus(status);
        break;
      default:
        setGstVerifyStatus('');
        setPanVerifyStatus('');
        setAadharVerifyStatus('');
    }
  };

  const handleVerifyDocumentNumber = async (number, type) => {
    if (!isEmpty(number)) {
      const documentObj = {
        pan: {
          name: 'Pan number Verification',
          regax: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
        },
        gst: {
          name: 'GST Number Verification',
          regax: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
        },
        generateaadhaarotp: {
          name: 'Aadhar Number',
          regax: /^\d{12}$/,
        },
      };
      if (documentObj[type].regax.test(number.toUpperCase())) {
        handleSetVerifyStatus(type, 'loading');
        const res = await verifyDocumentNumberApi(number.toUpperCase(), type);
        if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
          if (type === 'generateaadhaarotp') {
            if (res.ApiStatus.Result === 'already verified') {
              setAadharVerified(true);
              setAadharVerifyStatus('success');
              setIsLoading(false);
              return false;
            }
            setRequestId(res.ApiStatus.Result);
            setOpenVerificationPopup(true);
            return false;
          }
          if (type === 'pan') {
            setAgent((prev) => ({
              ...prev,
              name_pancard: res.ApiStatus?.Result?.full_name,
            }));
            setPanVerified(true);
          }
          if (type === 'gst') {
            setAgent((prev) => ({
              ...prev,
              gst_holder: res.ApiStatus?.Result?.business_name,
            }));
            setGstVerified(true);
          }
          setAlert({
            variant: 'success',
            title: documentObj[type].name,
            description: 'Verification Success',
          });
          handleSetVerifyStatus(type, 'success');
        } else {
          setAlert({
            variant: 'error',
            title: documentObj[type].name,
            description: 'Failed to Verify',
          });
          handleSetVerifyStatus(type, 'error');
        }
      }
    }
  };

  const handleChange = (event) => {
    const { name } = event.target;
    let { value } = event.target;
    if (name === 'state' || name === 'city') {
      value = value.replace(/[0-9]/g, '');
    }
    setAgent((current) => ({
      ...current,
      [name]: value,
    }));

    if (name === 'mobile_number') {
      if (selectedUserIdOption === 'mobile') {
        setAgent((current) => ({
          ...current,
          userid: value,
        }));
      }
    }
    if (name === 'contact_email') {
      if (selectedUserIdOption === 'email') {
        setAgent((current) => ({
          ...current,
          userid: value,
        }));
      }
    }
    if (name === 'gst_number' && appConfig?.isGstVerificationrequired) {
      setGstVerified(false);
      setGstVerifyStatus('');
      handleVerifyDocumentNumber(value, 'gst');
    }
    if (name === 'pan_number' && appConfig?.isPanVerificationrequired) {
      setPanVerified(false);
      setPanVerifyStatus('');
      handleVerifyDocumentNumber(value, 'pan');
    }
    if (name === 'aadhaar_number' && appConfig?.isAadharVerificationrequired) {
      setAadharVerified(false);
      setAadharVerifyStatus('');
      handleVerifyDocumentNumber(value, 'generateaadhaarotp');
    }
  };
  return (
    <div className="agent-registration-page">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={handleAlertHide}
        />
      )}
      <div className="app-container agent-registration-page__body mb-5">
        <div className="agent-registration-page__body_header p-3">
          <h2 className="agent-heading text-sm-">Registration</h2>
        </div>
        <div className="d-flex justify-content-end pe-3">
          <AppLink
            linkText="Back to Login"
            className="back-to-login-link"
            isLink={false}
            onClick={() => navigate(NAVIGATION_ROUTES.LOGIN)}
          />
        </div>
        <div className="separator"> </div>
        <Row className="personal-deatils-row">
          <h5>Personal Details</h5>
          <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
            <AppSelect
              required
              selectWidth="100"
              label="Select Salutation"
              className="traveller-input"
              name="salutation"
              id="salutation"
              placeholder=""
              errorText={validationError ? 'Please select salutation' : ''}
              options={salutationOptionsRef.current}
              selectedValue={agent.salutation}
              onSelect={(value) => handleSelectChange('salutation', value)}
            />
          </Col>
          <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
            <AppTextInput
              required
              name="first_name"
              id="first_name"
              label="First name"
              className="me-3"
              errorText={validationError ? 'Please enter first name' : ''}
              value={agent.first_name}
              onChange={(e) => handleChange(e)}
            />
            {checkValidName(agent.first_name) && (
              <small className="app-error-text">
                {formattedMessage('name_validation')}
              </small>
            )}
          </Col>
          <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
            <AppTextInput
              required
              name="last_name"
              id="last_name"
              label="Last name"
              errorText={validationError ? 'Please enter last name' : ''}
              value={agent.last_name}
              onChange={(e) => handleChange(e)}
            />
            {checkValidName(agent.last_name) && (
              <small className="app-error-text">
                {formattedMessage('name_validation')}
              </small>
            )}
          </Col>
          {/* <Col lg={2} md={2} sm={2} xs={12} className="mb-3">
            <AppSelect
              className="country-codes-input"
              name="countryCode"
              id="countryCode"
              label={formattedMessage('country_code')}
              placeholder=""
              required
              selectedValue={agent.countrymobilecode}
              options={countryCodeOptions}
              isClearable={false}
              errorText={
                validationError && formattedMessage('country_code_validation')
              }
              onSelect={(value) =>
                handleSelectChange('countrymobilecode', value)
              }
            />
          </Col> */}
          <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
            <AppSelect
              className="country-codes-input"
              name="countryCode"
              id="countryCode"
              label={formattedMessage('country_code')}
              placeholder=""
              required
              selectedValue={countryCode}
              options={mobileCodesForVerification}
              isClearable={false}
              errorText={
                validationError && formattedMessage('country_code_validation')
              }
              onSelect={(value) =>
                value !== null
                  ? setCountryCode(value.value)
                  : setCountryCode('')
              }
            />
          </Col>
          <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
            <AppTextInput
              required
              type="number"
              label="Mobile Number"
              name="mobile_number"
              id="mobile_number"
              className={
                validationError &&
                !isValidMobileNumber(agent.mobile_number, countryCode)
                  ? 'error-border'
                  : ''
              }
              value={agent.mobile_number}
              onChange={(e) => handleChange(e)}
            />
            {validationError &&
              !isValidMobileNumber(agent.mobile_number, countryCode) && (
                <small className="app-error-text">
                  Please Enter valid Mobile Number
                </small>
              )}
          </Col>
          <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
            <AppTextInput
              required
              name="contact_email"
              id="contact_email"
              label="Contact Email"
              errorText={validationError ? getEmailErrorMessage() : ''}
              className={
                agent.contact_email.trim() && getEmailErrorMessage()
                  ? 'error-border'
                  : ''
              }
              value={agent.contact_email}
              onChange={(e) => handleChange(e)}
            />
            {agent.contact_email.trim() && (
              <small className="app-error-text">{getEmailErrorMessage()}</small>
            )}
          </Col>
          <Col
            lg={4}
            md={4}
            sm={4}
            xs={12}
            className="d-flex flex-column gap-2 mt-2 mb-sm-0 mb-3"
          >
            {/* <AppButton
              variant="secondary"
              btnText="Verify Email &amp; Mobile"
              onClick={handleVerifyEmailAndMobileNumber}
              className="d-none"
            /> */}
            <AppRadioInput
              id="isPhoneSelectedAsUserId"
              name="useridoption"
              labelText="Use Mobile Number As User ID"
              onChange={() => setSelectedUserIdOption('mobile')}
              checked={selectedUserIdOption === 'mobile'}
            />
            <AppRadioInput
              id="isEmailSelectedAsUserId"
              name="useridoption"
              labelText="Use Email As User ID"
              onChange={() => setSelectedUserIdOption('email')}
              checked={selectedUserIdOption === 'email'}
            />
          </Col>
          <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
            <AppTextInput
              required
              name="userid"
              id="userid"
              label="User Id"
              className="w-100"
              // errorText={validationError && 'Please enter user id'}
              value={agent.userid}
              onChange={(e) => handleChange(e)}
              readOnly
            />
            {/* {!isEmpty(agent.first_name) &&
              !isEmpty(agent.last_name) &&
              !isEmpty(agent.mobile_number) &&
              agent.mobile_number.length === 10 && (
                <AppLink
                  linkText="Refresh"
                  onClick={generateRandomUserId}
                  className="fs-10 ps-2"
                />
              )} */}
          </Col>
          {getValueFromAppConfig('ADDREFERREDBYSALES') === 'true' && (
            <Col
              lg={4}
              md={4}
              sm={4}
              xs={12}
              className="d-flex flex-column gap-2 mt-2 mb-sm-0 mb-3"
            >
              <AppRadioInput
                id="referredBySelf"
                name="referrelid"
                labelText="Referred by Self"
                onChange={() => setIsReferredBySales(false)}
                checked={isReferredBySales === false}
              />
              <AppRadioInput
                id="referredByStaff"
                name="referrelid"
                labelText="Referred by Sales"
                onChange={() => setIsReferredBySales(true)}
                checked={isReferredBySales === true}
              />
            </Col>
          )}
          {isReferredBySales && (
            <Col lg={6} md={6} sm={6} xs={12}>
              <AppTextInput
                required
                name="referrerid"
                id="referrerid"
                label="Referral Name"
                className="w-100"
                value={agent.referrerid}
                onChange={handleChange}
                errorText={validationError && 'Please Referral Name'}
              />
            </Col>
          )}
        </Row>
        <Row className="company-details-row">
          <h5>Company Details</h5>
          <Col lg={3} md={3} sm={3} xs={12} className="mb-3">
            <AppSelect
              required
              selectWidth="100"
              label="Select User Category"
              className="traveller-input w-100"
              name="user_category"
              id="user_category"
              placeholder=""
              errorText={validationError && 'Please select category'}
              options={userCategoryOptionsRef.current}
              selectedValue={agent.user_category}
              onSelect={(value) => handleSelectChange('user_category', value)}
            />
          </Col>
          <Col lg={3} md={3} sm={3} xs={12} className="mb-3">
            <AppTextInput
              required
              name="company"
              id="company"
              label="Company Name"
              errorText={validationError && 'Please enter company name'}
              value={agent.company}
              onChange={handleChange}
            />
            {checkValidCompanyName(agent.company) && (
              <small className="app-error-text">
                Please enter valid company name
              </small>
            )}
          </Col>
          <Col lg={3} md={3} sm={3} xs={12} className="mb-3">
            <AppNumberInput
              required
              name="contact_number"
              id="contact_number"
              label="Contact Number"
              className={
                validationError &&
                !isValidMobileNumber(agent.contact_number, countryCode)
                  ? 'error-border'
                  : ''
              }
              value={agent.contact_number}
              onChange={(value) =>
                setAgent((current) => ({
                  ...current,
                  contact_number: value,
                }))
              }
            />
            {validationError &&
              !isValidMobileNumber(agent.contact_number, countryCode) && (
                <small className="app-error-text">
                  Please Enter valid Contact Number
                </small>
              )}
          </Col>
          <Col lg={3} md={3} sm={3} xs={12} className="mb-3">
            {isIndiaClient ? (
              <AppTextInput
                required
                name="country"
                id="country"
                label="Country"
                errorText={validationError && 'Please enter country'}
                value={agent.country}
                onChange={handleChange}
                readOnly
              />
            ) : (
              <AppSelect
                selectWidth="100"
                label="Select Country"
                className="traveller-input"
                name="country"
                id="country"
                required
                placeholder=""
                isClearable={false}
                errorText={validationError && 'Please select country'}
                options={
                  isIndiaClient
                    ? countryOptions.filter(
                        (option) => option.label === 'INDIA',
                      )
                    : countryOptions
                }
                selectedValue={agent.country}
                onSelect={(value) =>
                  handleSelectChangeCountry('country', value)
                }
              />
            )}
          </Col>
          <Col lg={3} md={3} sm={3} xs={12} className="mb-3">
            <AppTextInput
              required
              name="address1"
              id="address1"
              label="Address 1"
              errorText={validationError && 'Please enter Address 1'}
              value={agent.address1}
              onChange={handleChange}
            />
          </Col>
          <Col lg={3} md={3} sm={3} xs={12} className="mb-3">
            <AppTextInput
              name="address2"
              id="address2"
              label="Address 2"
              value={agent.address2}
              onChange={handleChange}
            />
          </Col>
          {showCompanyDetails ? (
            <>
              <Col lg={3} md={3} sm={3} xs={12} className="mb-3">
                <AppSelect
                  selectWidth="100"
                  label="Select State"
                  className="traveller-input"
                  name="state"
                  id="state"
                  required
                  placeholder=""
                  errorText={validationError ? 'Please select state' : ''}
                  options={stateOptionsRef.current}
                  selectedValue={agent.state}
                  onSelect={(value) => handleSelectChange('state', value)}
                />
              </Col>
              <Col lg={3} md={3} sm={3} xs={12} className="mb-3">
                <AppSelect
                  selectWidth="100"
                  label="Select City"
                  className="traveller-input"
                  name="city"
                  id="city"
                  required
                  placeholder=""
                  errorText={validationError && 'Please select city'}
                  options={cityOptionsRef.current}
                  selectedValue={agent.city}
                  onSelect={(value) => handleSelectChange('city', value)}
                />
              </Col>
            </>
          ) : (
            <>
              <Col lg={3} md={3} sm={3} xs={12} className="mb-3">
                <AppTextInput
                  required
                  name="state"
                  id="state"
                  label="State/Province"
                  errorText={validationError && 'Please enter State'}
                  value={agent.state}
                  onChange={handleChange}
                />
              </Col>
              <Col lg={3} md={3} sm={3} xs={12} className="mb-3">
                <AppTextInput
                  required
                  name="city"
                  id="city"
                  label="City"
                  errorText={validationError && 'Please enter city'}
                  value={agent.city}
                  onChange={handleChange}
                />
              </Col>
            </>
          )}

          <Col lg={3} md={3} sm={3} xs={12} className="mb-3">
            <AppTextInput
              required
              type="number"
              name="pincode"
              id="pincode"
              errorText={
                validationError &&
                `Please enter ${isUAEClient ? 'PO Box Number' : 'PIN code'}`
              }
              label={isUAEClient ? 'PO Box Number' : 'Pincode'}
              value={agent.pincode}
              onChange={handleChange}
            />
          </Col>
        </Row>
        {isUAEClient ? (
          <Row className="company-details-row">
            <h5>Company Details</h5>
            <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
              <AppTextInput
                name="vat_certificate_number"
                id="vat_certificate_number"
                label="VAT"
                value={agent.vat_certificate_number}
                onChange={handleChange}
              />
            </Col>
            <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
              <AppTextInput
                name="trade_license_number"
                id="trade_license_number"
                label="Trade Licence"
                value={agent.trade_license_number}
                onChange={handleChange}
              />
            </Col>
            <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
              <AppTextInput
                type="date"
                name="trade_license_expiry_date"
                id="trade_license_expiry_date"
                label="Trade Licence Expiry Date"
                value={agent.trade_license_expiry_date}
                onChange={handleChange}
              />
            </Col>
          </Row>
        ) : showCompanyDetails ? (
          (!appConfig.isIntlClient || appConfig.isIntlClient === 'false') && (
            <>
              <Row className="company-details-row">
                <h5>Pan Details</h5>
                <Col
                  lg={4}
                  md={4}
                  sm={4}
                  xs={12}
                  className="mb-3 position-relative"
                >
                  <AppTextInput
                    required={isPanAndGstMandatory}
                    name="pan_number"
                    id="pan_number"
                    label="PAN Number"
                    maxLength="10"
                    errorText={
                      isPanAndGstMandatory &&
                      validationError &&
                      'Please enter PAN number'
                    }
                    value={agent.pan_number}
                    onChange={handleChange}
                  />
                  {panVerifyStatus !== '' && (
                    <span
                      className={panVerifyStatus === 'loading' ? 'spinner' : ''}
                      style={{
                        position: 'absolute',
                        right: '-2px',
                        top: '13px',
                        width: '14px',
                        height: '14px',
                        transform: 'translateY(-50%)',
                      }}
                    >
                      {panVerifyStatus === 'loading' ? (
                        ''
                      ) : panVerifyStatus === 'success' ? (
                        <MdCheck className="green-color" />
                      ) : panVerifyStatus === 'error' ? (
                        <MdClear className="red-color" />
                      ) : (
                        ''
                      )}
                    </span>
                  )}
                </Col>
                <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
                  <AppTextInput
                    required={isPanAndGstMandatory}
                    name="name_pancard"
                    id="name_pancard"
                    label="Name on PAN"
                    disabled={appConfig?.isPanVerificationrequired}
                    errorText={
                      isPanAndGstMandatory &&
                      validationError &&
                      'Please enter PAN name'
                    }
                    value={agent.name_pancard}
                    onChange={handleChange}
                  />
                  {checkValidName(agent.name_pancard) && (
                    <small className="app-error-text">
                      {formattedMessage('name_validation_pan')}
                    </small>
                  )}
                </Col>
                <Col
                  lg={4}
                  md={4}
                  sm={4}
                  xs={12}
                  className="d-flex flex-column mb-3 fs-14"
                >
                  <label
                    htmlFor="upload_pan"
                    className={`secondary-text ${
                      isPanAndGstMandatory ? 'required ' : ''
                    }registration-upload-file-label`}
                  >
                    Upload PAN{' '}
                    {isPanAndGstMandatory && (
                      <span style={{ color: 'red' }}>*</span>
                    )}
                  </label>
                  <input
                    type="file"
                    accept="image/*,.pdf,.docx,.xlsx"
                    className="file-upload border border-primary mt-2 mb-2"
                    name="upload-PAN"
                    id="upload_pan"
                    disabled={isEmpty(agent.pan_number)}
                    ref={panDocRef}
                    onChange={(e) =>
                      handleImageUploadForRegistration(
                        e,
                        'pannumber',
                        'pan_doc_url',
                      )
                    }
                  />
                  <span className="secondary-text">
                    Max size: 4MB, Allowed types: jpeg, jpg, png, pdf
                  </span>
                  {agent.pan_doc_url && (
                    <a
                      style={{ display: 'block', fontSize: 12 }}
                      rel="noopener noreferrer"
                      target="_blank"
                      href={agent.pan_doc_url}
                    >
                      Click Here to view uploaded PAN
                    </a>
                  )}
                  {isPanAndGstMandatory &&
                    validationError &&
                    !agent.pan_doc_url && (
                      <small className="error-text">
                        Please upload PAN document
                      </small>
                    )}
                </Col>
              </Row>
              <Row className="company-details-row">
                <h5>GST Details</h5>
                <Col
                  lg={4}
                  md={4}
                  sm={4}
                  xs={12}
                  className="mb-3 position-relative"
                >
                  <AppTextInput
                    name="gst_number"
                    id="gst_number"
                    label="GST Number"
                    required={appConfig.isGstVerificationrequired}
                    errorText={
                      isPanAndGstMandatory &&
                      validationError &&
                      'Please enter GST Number'
                    }
                    value={agent.gst_number}
                    onChange={handleChange}
                  />
                  {gstVerifyStatus !== '' && (
                    <span
                      className={gstVerifyStatus === 'loading' ? 'spinner' : ''}
                      style={{
                        position: 'absolute',
                        right: '-2px',
                        top: '13px',
                        width: '14px',
                        height: '14px',
                        transform: 'translateY(-50%)',
                      }}
                    >
                      {gstVerifyStatus === 'loading' ? (
                        ''
                      ) : gstVerifyStatus === 'success' ? (
                        <MdCheck className="green-color" />
                      ) : gstVerifyStatus === 'error' ? (
                        <MdClear className="red-color" />
                      ) : (
                        ''
                      )}
                    </span>
                  )}
                </Col>
                <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
                  <AppTextInput
                    name="gst_holder"
                    id="gst_holder"
                    // disabled={appConfig?.isGstVerificationrequired}
                    label="GST Holder"
                    required={appConfig?.isGstVerificationrequired}
                    errorText={
                      isPanAndGstMandatory &&
                      validationError &&
                      'Please enter GST Holder'
                    }
                    value={agent.gst_holder}
                    onChange={handleChange}
                  />
                  {checkValidName(agent.gst_holder) && (
                    <small className="app-error-text">
                      {formattedMessage('name_validation')}
                    </small>
                  )}
                </Col>

                <Col
                  lg={4}
                  md={4}
                  sm={4}
                  xs={12}
                  className="d-flex flex-column mb-3 fs-14"
                >
                  <label
                    htmlFor="upload_GST"
                    className="secondary-text registration-upload-file-label"
                  >
                    Upload GST Registration{' '}
                    {appConfig?.isGstVerificationrequired ? '*' : ''}
                  </label>
                  <input
                    type="file"
                    accept="image/*,.pdf,.docx,.xlsx"
                    className="file-upload border border-primary mt-2 mb-2"
                    name="upload-GST"
                    disabled={isEmpty(agent.gst_number)}
                    id="upload_GST"
                    onChange={(e) =>
                      handleImageUploadForRegistration(e, 'gst', 'gst_doc_url')
                    }
                  />
                  <span className="secondary-text">
                    Max size: 4MB, Allowed types: jpeg, jpg, png, pdf
                  </span>
                  {agent.gst_doc_url && (
                    <a
                      style={{ display: 'block', fontSize: 12 }}
                      rel="noopener noreferrer"
                      target="_blank"
                      href={agent.gst_doc_url}
                    >
                      Click Here to view uploaded GST Document
                    </a>
                  )}
                  {validationError &&
                    (agent.user_category === 'organization' ||
                      appConfig?.isGstVerificationrequired) &&
                    !agent.gst_doc_url && (
                      <small className="error-text">
                        Please upload GST document
                      </small>
                    )}
                </Col>
              </Row>
            </>
          )
        ) : (
          <>
            <Row className="company-details-row">
              <h5>Company Incorporation Certificate</h5>
              <Col lg={6} md={6} sm={6} xs={12} className="mb-3">
                <AppTextInput
                  required
                  name="company_incorporation_number"
                  id="company_incorporation_number"
                  label="C.I number"
                  errorText={
                    validationError &&
                    'Please enter Company Incorporation Number'
                  }
                  value={agent.company_incorporation_number}
                  onChange={handleChange}
                />
              </Col>
              <Col
                lg={6}
                md={6}
                sm={6}
                xs={12}
                className="d-flex flex-column mb-3 fs-14"
              >
                <label
                  htmlFor="upload_incorporation"
                  className="secondary-text required registration-upload-file-label"
                >
                  Upload Company Incorporation Certificate *
                </label>
                <input
                  type="file"
                  accept="image/*,.pdf,.docx,.xlsx"
                  className="file-upload border border-primary mt-2 mb-2"
                  name="upload-incorporation"
                  disabled={isEmpty(agent.company_incorporation_number)}
                  id="upload_incorporation"
                  onChange={(e) =>
                    handleImageUploadForRegistration(
                      e,
                      'incorporation',
                      'company_incorporation_doc_url',
                    )
                  }
                />
                <span className="secondary-text">
                  Max size: 4MB, Allowed types: jpeg, jpg, png, pdf
                </span>
                {agent.company_incorporation_doc_url && (
                  <a
                    style={{ display: 'block', fontSize: 12 }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={agent.company_incorporation_doc_url}
                  >
                    Click Here to view uploaded Incorporation Certificate
                  </a>
                )}
                {validationError && !agent.company_incorporation_doc_url && (
                  <small className="error-text">
                    Please upload Incorporation Certificate
                  </small>
                )}
              </Col>
            </Row>
            <Row className="company-details-row">
              <h5>TIN/VAT Details(optional)</h5>
              <Col lg={6} md={6} sm={6} xs={12} className="mb-3">
                <AppTextInput
                  name="tax_identification_number"
                  id="tax_identification_number"
                  label="TIN/VAT Number"
                  value={agent.tax_identification_number}
                  onChange={handleChange}
                />
              </Col>
              <Col
                lg={6}
                md={6}
                sm={6}
                xs={12}
                className="d-flex flex-column mb-3 fs-14"
              >
                <label
                  htmlFor="upload_tinvat"
                  className="secondary-text registration-upload-file-label"
                >
                  Upload TIN/VAT
                </label>
                <input
                  type="file"
                  accept="image/*,.pdf,.docx,.xlsx"
                  className="file-upload border border-primary mt-2 mb-2"
                  name="upload-tinvat"
                  id="upload_tinvat"
                  onChange={(e) =>
                    handleImageUploadForRegistration(
                      e,
                      'tinvat',
                      'tax_identification_doc_url',
                    )
                  }
                  disabled={isEmpty(agent.tax_identification_number)}
                />
                <span className="secondary-text">
                  Max size: 4MB, Allowed types: jpeg, jpg, png, pdf
                </span>
                {agent.tax_identification_doc_url && (
                  <a
                    style={{ display: 'block', fontSize: 12 }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={agent.tax_identification_doc_url}
                  >
                    Click Here to view uploaded TIN / VAT Detail
                  </a>
                )}
                {validationError &&
                  !isEmpty(agent.tax_identification_number) &&
                  !agent.tax_identification_doc_url && (
                    <small className="error-text">
                      Please upload TIN / VAT Detail
                    </small>
                  )}
              </Col>
            </Row>
            <Row className="company-details-row">
              <h5>IATA Certificate (if the agency is IATA-approved)</h5>
              <Col lg={6} md={6} sm={6} xs={12} className="mb-3">
                <AppTextInput
                  name="iata_number"
                  id="iata_number"
                  label="Company IATA Number"
                  value={agent.iata_number}
                  onChange={handleChange}
                />
              </Col>
              <Col
                lg={6}
                md={6}
                sm={6}
                xs={12}
                className="d-flex flex-column mb-3 fs-14"
              >
                <label
                  htmlFor="upload_iata"
                  className="secondary-text registration-upload-file-label"
                >
                  Upload IATA Document
                </label>
                <input
                  type="file"
                  accept="image/*,.pdf,.docx,.xlsx"
                  className="file-upload border border-primary mt-2 mb-2"
                  name="upload-iata"
                  id="upload_iata"
                  onChange={(e) =>
                    handleImageUploadForRegistration(
                      e,
                      'iata',
                      'iata_certificate_url',
                    )
                  }
                  disabled={isEmpty(agent.iata_number)}
                />
                <span className="secondary-text">
                  Max size: 4MB, Allowed types: jpeg, jpg, png, pdf
                </span>
                {agent.iata_certificate_url && (
                  <a
                    style={{ display: 'block', fontSize: 12 }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={agent.iata_certificate_url}
                  >
                    Click Here to view uploaded IATA Certificate
                  </a>
                )}
                {validationError &&
                  !isEmpty(agent.iata_number) &&
                  !agent.iata_certificate_url && (
                    <small className="error-text">
                      Please upload IATA Certificate
                    </small>
                  )}
              </Col>
            </Row>
            <Row className="company-details-row">
              <h5>
                Membership Certificates (e.g., ASTA, ABTA, ATOL, TAAI, UFTAA, or
                other regional travel associations)
              </h5>
              <Col lg={6} md={6} sm={6} xs={12} className="mb-3">
                <AppTextInput
                  required
                  name="membership_cert_number"
                  id="membership_cert_number"
                  label="ASTA, ABTA, ATOL, TAAI, UFTAA Number"
                  errorText={
                    validationError && 'Please enter Membership Number'
                  }
                  value={agent.membership_cert_number}
                  onChange={handleChange}
                />
              </Col>
              <Col
                lg={6}
                md={6}
                sm={6}
                xs={12}
                className="d-flex flex-column mb-3 fs-14"
              >
                <label
                  htmlFor="upload_membership"
                  className="secondary-text required registration-upload-file-label"
                >
                  Upload Membership Document
                </label>
                <input
                  type="file"
                  accept="image/*,.pdf,.docx,.xlsx"
                  className="file-upload border border-primary mt-2 mb-2"
                  name="upload-membership"
                  id="upload_membership"
                  onChange={(e) =>
                    handleImageUploadForRegistration(
                      e,
                      'membership',
                      'membership_cert_doc_url',
                    )
                  }
                  disabled={isEmpty(agent.membership_cert_number)}
                />
                <span className="secondary-text">
                  Max size: 4MB, Allowed types: jpeg, jpg, png, pdf
                </span>
                {agent.membership_cert_doc_url && (
                  <a
                    style={{ display: 'block', fontSize: 12 }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={agent.membership_cert_doc_url}
                  >
                    Click Here to view uploaded Membership Document
                  </a>
                )}
                {validationError && !agent.company_incorporation_doc_url && (
                  <small className="error-text">
                    Please upload Membership Document
                  </small>
                )}
              </Col>
            </Row>
          </>
        )}

        <Row className="company-details-row">
          <h5>
            Documents Verification
            {showCompanyDetails && ''}
          </h5>
          {/* <Col lg={3} md={3} sm={3} xs={6}>
            <AppCheckBox
              id="license"
              name="document"
              labelText="Driving License"
              labelClassName="fs-14"
              onChange={() => setIsLicenseSelected(!isLicenseSelected)}
              checked={isLicenseSelected}
            />
          </Col> */}
          {!isUAEClient && (
            <Col lg={3} md={3} sm={3} xs={4}>
              <AppCheckBox
                id="passport"
                name="document"
                labelText="Passport"
                labelClassName="fs-14"
                onChange={() => setIsPassportSelected(!isPassportSelected)}
                checked={isPassportSelected}
              />
            </Col>
          )}
          {isUAEClient && (
            <Col lg={3} md={3} sm={3} xs={4}>
              <AppCheckBox
                id="trade_license"
                name="document"
                labelText="Trade License"
                labelClassName="fs-14"
                onChange={() =>
                  setIsTradeLicenseSelected(!isTradeLicenseSelected)
                }
                checked={isTradeLicenseSelected}
              />
            </Col>
          )}
          {isUAEClient && (
            <Col lg={3} md={3} sm={3} xs={4}>
              <AppCheckBox
                id="vat_certificate"
                name="document"
                labelText="VAT Certificate"
                labelClassName="fs-14"
                onChange={() =>
                  setIsVatCertificateSelected(!isVatCertificateSelected)
                }
                checked={isVatCertificateSelected}
              />
            </Col>
          )}
          {showCompanyDetails &&
            (!appConfig.isIntlClient || appConfig.isIntlClient === 'false') && (
              <>
                <Col lg={3} md={3} sm={3} xs={4}>
                  <AppCheckBox
                    id="aadhar"
                    name="document"
                    labelText="Aadhar Card"
                    labelClassName="fs-14"
                    onChange={() => setIsAadharSelected(!isAadharSelected)}
                    checked={isAadharSelected}
                  />
                </Col>
                <Col lg={3} md={3} sm={3} xs={4}>
                  <AppCheckBox
                    id="voter"
                    name="document"
                    labelText="Voter Id"
                    labelClassName="fs-14"
                    onChange={() => setIsVoterSelected(!isVoterSelected)}
                    checked={isVoterSelected}
                  />
                </Col>
                {getValueFromAppConfig('REQUIRE_LICENSE') === 'true' && (
                  <Col lg={3} md={3} sm={3} xs={4}>
                    <AppCheckBox
                      id="license"
                      name="document"
                      labelText="Driving License"
                      labelClassName="fs-14"
                      onChange={() => setIsLicenseSelected(!isLicenseSelected)}
                      checked={isLicenseSelected}
                    />
                  </Col>
                )}
              </>
            )}
          {!appConfig.isIntlClient === 'false' && (
            <Col lg={3} md={3} sm={3} xs={6}>
              <AppCheckBox
                id="VAT"
                name="document"
                labelText="VAT Certificate"
                labelClassName="fs-14"
                onChange={() => setIsVatSelected(!isVatSelected)}
                checked={isVatSelected}
              />
            </Col>
          )}
        </Row>

        {(isAadharSelected ||
          isLicenseSelected ||
          isVoterSelected ||
          (isPassportSelected && !isUAEClient) ||
          isVatSelected ||
          (isUAEClient && isVatCertificateSelected) ||
          (isUAEClient && isTradeLicenseSelected)) && (
          <Row className="company-details-row">
            {isPassportSelected && !isUAEClient && (
              <Col lg={3} md={3} sm={3} xs={12}>
                <div>
                  <AppTextInput
                    name="passport_number"
                    id="passport_number"
                    label="Passport Number"
                    errorText={
                      validationError &&
                      isPassportSelected &&
                      'Please enter Passport Number'
                    }
                    value={agent.passport_number}
                    onChange={handleChange}
                    required
                  />
                  {validationError &&
                    !isEmpty(agent.passport_number) &&
                    PASSPORT_REGAX.test(agent.passport_number) === false && (
                      <small className="error-text">
                        Please enter valid Passport Number
                      </small>
                    )}
                  <div className="d-flex flex-column my-2">
                    <label
                      htmlFor="upload_passport_front"
                      className="secondary-text"
                    >
                      Upload Passport Front Page{' '}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      accept="image/*,.pdf,.docx,.xlsx"
                      className="file-upload border border-primary mb-2"
                      name="upload_passport_front"
                      disabled={isEmpty(agent.passport_number)}
                      id="upload_passport_front"
                      onChange={(e) =>
                        handleImageUploadForRegistration(
                          e,
                          'passport',
                          'passport_front_doc_url',
                        )
                      }
                    />
                    <span className="secondary-text">
                      Max size: 4MB, Allowed types: jpeg, jpg, png, pdf
                    </span>
                    {agent.passport_front_doc_url !== '' && (
                      <a
                        style={{ display: 'block', fontSize: 12 }}
                        rel="noopener noreferrer"
                        target="_blank"
                        href={agent.passport_front_doc_url}
                      >
                        Click Here to view Passport front page
                      </a>
                    )}
                    {isPassportSelected &&
                      validationError &&
                      agent.passport_front_doc_url === '' && (
                        <small className="error-text">
                          Please upload Passport front page
                        </small>
                      )}
                  </div>
                  <div className="d-flex flex-column my-2">
                    <label
                      htmlFor="upload_passport_back"
                      className="secondary-text"
                    >
                      Upload Passport back Page
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      accept="image/*,.pdf,.docx,.xlsx"
                      className="file-upload border border-primary mb-2"
                      name="upload_passport_back"
                      disabled={isEmpty(agent.passport_number)}
                      id="upload_passport_back"
                      ref={gstDocRef}
                      onChange={(e) =>
                        handleImageUploadForRegistration(
                          e,
                          'passport',
                          'passport_back_doc_url',
                        )
                      }
                    />
                    <span className="secondary-text">
                      Max size: 4MB, Allowed types: jpeg, jpg, png, pdf
                    </span>
                    {agent.passport_back_doc_url !== '' && (
                      <a
                        style={{ display: 'block', fontSize: 12 }}
                        rel="noopener noreferrer"
                        target="_blank"
                        href={agent.passport_back_doc_url}
                      >
                        Click Here to view Passport back page
                      </a>
                    )}
                    {isPassportSelected &&
                      validationError &&
                      agent.passport_back_doc_url === '' && (
                        <small className="error-text">
                          Please upload Passport back page
                        </small>
                      )}
                  </div>
                </div>
              </Col>
            )}
            {isUAEClient && isTradeLicenseSelected && (
              <Col lg={3} md={3} sm={3} xs={12}>
                <div>
                  <div className="d-flex flex-column my-2">
                    <label
                      htmlFor="upload_trade_license"
                      className="secondary-text required"
                    >
                      Trade License *
                    </label>
                    <input
                      type="file"
                      accept="image/*,.pdf"
                      className="file-upload border border-primary mb-2"
                      name="upload_trade_license"
                      disabled={isEmpty(agent.trade_license_number)}
                      id="upload_trade_license"
                      onChange={(e) =>
                        handleImageUploadForRegistration(
                          e,
                          'incorporation',
                          'trade_license_doc_url',
                        )
                      }
                    />
                    <span className="secondary-text">
                      Click to upload — PDF / image
                    </span>
                    {agent.trade_license_doc_url !== '' && (
                      <a
                        style={{ display: 'block', fontSize: 12 }}
                        rel="noopener noreferrer"
                        target="_blank"
                        href={agent.trade_license_doc_url}
                      >
                        Click Here to view Trade License
                      </a>
                    )}
                    {validationError && agent.trade_license_doc_url === '' && (
                      <small className="error-text">
                        Please upload Trade License
                      </small>
                    )}
                  </div>
                </div>
              </Col>
            )}
            {isUAEClient && isVatCertificateSelected && (
              <Col lg={3} md={3} sm={6} xs={12} className="mb-3">
                <label
                  htmlFor="upload_vat_certificate"
                  className="secondary-text registration-upload-file-label"
                >
                  Upload VAT Certificate
                </label>
                <input
                  type="file"
                  accept="image/*,.pdf"
                  className="file-upload border border-primary mt-2 mb-2"
                  name="upload-vat-certificate"
                  id="upload_vat_certificate"
                  disabled={isEmpty(agent.vat_certificate_number)}
                  onChange={(e) =>
                    handleImageUploadForRegistration(
                      e,
                      'tinvat',
                      'vat_certificate_doc_url',
                    )
                  }
                />
                {agent.vat_certificate_doc_url && (
                  <a
                    style={{ display: 'block', fontSize: 12 }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={agent.vat_certificate_doc_url}
                  >
                    View VAT Certificate
                  </a>
                )}
              </Col>
            )}
            {showCompanyDetails &&
              (!appConfig.isIntlClient ||
                appConfig.isIntlClient === 'false') && (
                <>
                  <Col lg={3} md={3} sm={3} xs={12}>
                    {isAadharSelected && (
                      <div>
                        <div className="d-flex flex-1 position-relative">
                          <AppTextInput
                            name="aadhaar_number"
                            id="aadhaar_number"
                            label="Aadhar Number"
                            errorText={
                              validationError &&
                              isAadharSelected &&
                              'Please enter Aadhar Number'
                            }
                            wrapperClassName="flex-1"
                            value={agent.aadhaar_number}
                            onChange={handleChange}
                          />
                          {aadharVerifyStatus !== '' && (
                            <span
                              className={
                                aadharVerifyStatus === 'loading'
                                  ? 'spinner'
                                  : ''
                              }
                              style={{
                                position: 'absolute',
                                right: '-2px',
                                top: '13px',
                                width: '14px',
                                height: '14px',
                                transform: 'translateY(-50%)',
                              }}
                            >
                              {aadharVerifyStatus === 'loading' ? (
                                ''
                              ) : aadharVerifyStatus === 'success' ? (
                                <MdCheck className="green-color" />
                              ) : aadharVerifyStatus === 'error' ? (
                                <MdClear className="red-color" />
                              ) : (
                                ''
                              )}
                            </span>
                          )}
                        </div>
                        <div className="d-flex flex-column my-2">
                          <label
                            htmlFor="upload_aadhar"
                            className="secondary-text"
                          >
                            Upload Aadhar Document
                          </label>
                          <input
                            type="file"
                            accept="image/*,.pdf,.docx,.xlsx"
                            className="file-upload border border-primary mb-2"
                            name="upload_aadhar"
                            disabled={isEmpty(agent.aadhaar_number)}
                            id="upload_aadhar"
                            // ref={gstDocRef}
                            onChange={(e) =>
                              handleImageUploadForRegistration(
                                e,
                                'aadhaar',
                                'aadhaar_doc_url',
                              )
                            }
                          />
                          <span className="secondary-text">
                            Max size: 4MB, Allowed types: jpeg, jpg, png, pdf
                          </span>
                          {agent.aadhaar_doc_url !== '' && (
                            <a
                              style={{ display: 'block', fontSize: 12 }}
                              rel="noopener noreferrer"
                              target="_blank"
                              href={agent.aadhaar_doc_url}
                            >
                              Click Here to view uploaded address Document
                            </a>
                          )}
                          {isAadharSelected &&
                            validationError &&
                            agent.aadhaar_doc_url === '' && (
                              <small className="error-text">
                                Please upload Aadhaar document
                              </small>
                            )}
                        </div>
                      </div>
                    )}
                  </Col>
                  <Col lg={3} md={3} sm={3} xs={12}>
                    {isVoterSelected && (
                      <div>
                        <AppTextInput
                          name="voterid_number"
                          id="voterid_number"
                          label="Voter Number"
                          errorText={
                            validationError &&
                            isVoterSelected &&
                            'Please enter Voter Number'
                          }
                          value={agent.voterid_number}
                          onChange={handleChange}
                        />
                        <div className="d-flex flex-column my-2">
                          <label
                            htmlFor="upload_voter"
                            className="secondary-text"
                          >
                            Upload Voter Document
                          </label>
                          <input
                            type="file"
                            accept="image/*,.pdf,.docx,.xlsx"
                            className="file-upload border border-primary mb-2"
                            name="upload_voter"
                            disabled={isEmpty(agent.voterid_number)}
                            id="upload_voter"
                            onChange={(e) =>
                              handleImageUploadForRegistration(
                                e,
                                'voterid',
                                'voterid_doc_url',
                              )
                            }
                          />
                          <span className="secondary-text">
                            Max size: 4MB, Allowed types: jpeg, jpg, png, pdf
                          </span>
                          {agent.voterid_doc_url !== '' && (
                            <a
                              style={{ display: 'block', fontSize: 12 }}
                              rel="noopener noreferrer"
                              target="_blank"
                              href={agent.voterid_doc_url}
                            >
                              Click Here to view uploaded Voter Document
                            </a>
                          )}
                          {isVoterSelected &&
                            validationError &&
                            agent.voterid_doc_url === '' && (
                              <small className="error-text">
                                Please upload Voter document
                              </small>
                            )}
                        </div>
                      </div>
                    )}
                  </Col>
                  <Col lg={3} md={3} sm={3} xs={12}>
                    {isLicenseSelected && (
                      <div>
                        <AppTextInput
                          name="driving_license_number"
                          id="driving_license_number"
                          label="Driving License Number"
                          errorText={
                            validationError &&
                            isLicenseSelected &&
                            'Please enter Driving License Number'
                          }
                          value={agent.driving_license_number}
                          onChange={handleChange}
                        />
                        <div className="d-flex flex-column my-2">
                          <label
                            htmlFor="upload_license"
                            className="secondary-text"
                          >
                            Upload Driving License
                          </label>
                          <input
                            type="file"
                            accept="image/*,.pdf,.docx,.xlsx"
                            className="file-upload border border-primary mb-2"
                            name="upload_license"
                            disabled={isEmpty(agent.driving_license_number)}
                            id="upload_license"
                            onChange={(e) =>
                              handleImageUploadForRegistration(
                                e,
                                'drivinglicence',
                                'driving_license_doc_url',
                              )
                            }
                          />
                          <span className="secondary-text">
                            Max size: 4MB, Allowed types: jpeg, jpg, png, pdf
                          </span>
                          {agent.driving_license_doc_url !== '' && (
                            <a
                              style={{ display: 'block', fontSize: 12 }}
                              rel="noopener noreferrer"
                              target="_blank"
                              href={agent.driving_license_doc_url}
                            >
                              Click Here to view uploaded Driving License
                            </a>
                          )}
                          {isLicenseSelected &&
                            validationError &&
                            agent.driving_license_doc_url === '' && (
                              <small className="error-text">
                                Please upload Driving License document
                              </small>
                            )}
                        </div>
                      </div>
                    )}
                  </Col>
                </>
              )}
            {isVatSelected && (
              <Col lg={3} md={3} sm={3} xs={12}>
                <div>
                  <AppTextInput
                    name="aadhaar_number"
                    id="aadhaar_number"
                    label="VAT Number"
                    errorText={
                      validationError &&
                      isAadharSelected &&
                      'Please enter VAT Number'
                    }
                    value={agent.aadhaar_number}
                    onChange={handleChange}
                  />
                  <div className="d-flex flex-column my-2">
                    <label htmlFor="upload_aadhar" className="secondary-text">
                      Upload VAT Certificate
                    </label>
                    <input
                      type="file"
                      accept="image/*,.pdf,.docx,.xlsx"
                      className="file-upload border border-primary mb-2"
                      name="upload_aadhar"
                      disabled={isEmpty(agent.aadhaar_number)}
                      id="upload_aadhar"
                      // ref={gstDocRef}
                      onChange={(e) =>
                        handleImageUploadForRegistration(
                          e,
                          'aadhaar',
                          'aadhaar_doc_url',
                        )
                      }
                    />
                    <span className="secondary-text">
                      Max size: 4MB, Allowed types: jpeg, jpg, png, pdf
                    </span>
                    {agent.aadhaar_doc_url !== '' && (
                      <a
                        style={{ display: 'block', fontSize: 12 }}
                        rel="noopener noreferrer"
                        target="_blank"
                        href={agent.aadhaar_doc_url}
                      >
                        Click Here to view VAT Document
                      </a>
                    )}
                    {isAadharSelected &&
                      validationError &&
                      agent.aadhaar_doc_url === '' && (
                        <small className="error-text">
                          Please upload VAT document
                        </small>
                      )}
                  </div>
                </div>
              </Col>
            )}
          </Row>
        )}

        <Row className="company-details-row">
          <Col>
            <div className="mt-4">
              <label className="d-flex align-items-center">
                <AppCheckBox
                  id="acceptTerms"
                  name="acceptTerms"
                  checked={acceptTerms}
                  labelClassName="fs-12"
                  onChange={() => setAcceptTerms((prev) => !prev)}
                />
                <span className="ms-2">
                  I have Read and Accept
                  <a
                    className="ms-1"
                    href="/terms-conditions"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Terms & Conditions
                  </a>
                </span>
              </label>
            </div>
          </Col>
        </Row>
        {acceptTerms && (
          <div className="text-center mt-4 mb-4">
            <AppButton
              onClick={handleSubmit}
              btnText="Submit"
              className="px-5"
            />
          </div>
        )}
      </div>
      <Modal
        backdrop="static"
        keyboard={false}
        show={openVerificationPopup}
        onHide={() => setOpenVerificationPopup(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Verify OTP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OtpVerificationModal
            email={agent.contact_email}
            mobileNumber={agent.mobile_number}
            onVerifyOtp={handleOtpVerification}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}
